import React from "react";
import { Alert, AlertTitle, Box, Chip, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

/**
 * Reusable warning component for items missing a current import price.
 *
 * Props:
 *   items  - array of { name: string, importId: number }
 *   title  - optional custom title string
 *   message - optional custom body message
 */
function MissingPriceWarning({ items, title, message }) {
  if (!items || items.length === 0) return null;

  return (
    <Alert severity="warning" icon={<WarningAmberIcon />} sx={{ mt: 1 }}>
      <AlertTitle>{title || "Price Not Available"}</AlertTitle>
      <Typography variant="body2" mb={1}>
        {message ||
          "Current price is not set for the following input items. Material cost calculation may be incomplete:"}
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
        {items.map((item, index) => (
          <Chip
            key={item.importId ?? index}
            label={item.name}
            size="small"
            color="warning"
            variant="outlined"
          />
        ))}
      </Box>
    </Alert>
  );
}

export default MissingPriceWarning;
